import React, { useContext } from 'react';
import classNames from 'classnames';
import { StateContext } from '@/v2/state/store';
import './Loading.scss';

export default () => {
    const store = useContext(StateContext);
    const { state } = store;

    const loadingClassName = classNames('Loading', {
        'Loading--light': state.lightBgEnabled,
    });

    return (
        <div className={loadingClassName}>
            <div className="Loading__animation" style={{ backgroundImage: `url('${window.HELIOS.publicPath}images/loading-2x.png')` }} />
        </div>
    );
};
